import { useCallback, useState } from 'react';

import type { ReDubSelectionRequest } from '@src/components/transcript/hooks/useSpanReplace';

/**
 * PLAT-12022 — owns the open/closed state of `RedubSelectionPopover`, the
 * selection re-dub popover, the way `useDubGenerateModalController` owns the
 * dub modal's. One per host (the Transcript & Languages tab, the clip
 * transcript bridge), so each mounts the popover once and every selection
 * entry on that surface opens the same one.
 *
 * `open(language, request)` holds the reviewed language and the selection the
 * menu handed up (its dub line ids, speakers and anchor); the popover is
 * mounted only while one is held.
 */
export interface RedubSelectionOpen {
  language: string;
  request: ReDubSelectionRequest;
}

export function useRedubSelectionController(): {
  current: RedubSelectionOpen | null;
  open: (language: string, request: ReDubSelectionRequest) => void;
  close: () => void;
} {
  const [current, setCurrent] = useState<RedubSelectionOpen | null>(null);
  const open = useCallback(
    (language: string, request: ReDubSelectionRequest) =>
      setCurrent({ language, request }),
    [],
  );
  const close = useCallback(() => setCurrent(null), []);
  return { current, open, close };
}
